/*
 * swMessageBus
 *
 * An abstraction layer to send messages to the Service Worker from the client
 */

import { EventEmitter } from 'events';

const swMessageBus = new EventEmitter();

swMessageBus.on('message', (message) => {
    if (!('serviceWorker' in navigator)) {
        console.error('ERROR @swMessageBus: navigator.serviceWorker must be defined', navigator.serviceWorker);
        return false;
    }

    if (!message) {
        console.error('ERROR @swMessageBus: message must be defined', message);
        return false;
    }

    try {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.active.postMessage(message);
            }).catch((error) => {
                console.error('[swMessageBus] ERROR:', error);
            });
    } catch (error) {
        console.error('ERROR @swMessageBus', error);
    }

    return false;
});

export default swMessageBus;
